import React from 'react';
import BSPagination from 'react-bootstrap/Pagination';

interface Props {
  currentPage: number;
  totalPages: number;
  // eslint-disable-next-line no-unused-vars
  onChange: (page: number) => void;
}

function Pagination({ currentPage, totalPages, onChange }: Props) {
  if (totalPages <= 1) return null;

  const items: React.ReactElement[] = [];
  const windowSize = 2;
  const start = Math.max(1, currentPage - windowSize);
  const end = Math.min(totalPages, currentPage + windowSize);

  function pageItem(p: number, active = false) {
    return (
      <BSPagination.Item key={p} active={active} onClick={() => onChange(p)}>
        {p}
      </BSPagination.Item>
    );
  }

  items.push(
    <BSPagination.First
      key="first"
      disabled={currentPage === 1}
      onClick={() => onChange(1)}
    />
  );
  items.push(
    <BSPagination.Prev
      key="prev"
      disabled={currentPage === 1}
      onClick={() => onChange(Math.max(1, currentPage - 1))}
    />
  );

  if (start > 1) {
    items.push(pageItem(1));
    if (start > 2) {
      items.push(<BSPagination.Ellipsis key="ell-left" disabled />);
    }
  }

  for (let p = start; p <= end; p += 1) {
    items.push(pageItem(p, p === currentPage));
  }

  if (end < totalPages) {
    if (end < totalPages - 1) {
      items.push(<BSPagination.Ellipsis key="ell-right" disabled />);
    }
    items.push(pageItem(totalPages));
  }

  items.push(
    <BSPagination.Next
      key="next"
      disabled={currentPage === totalPages}
      onClick={() => onChange(Math.min(totalPages, currentPage + 1))}
    />
  );
  items.push(
    <BSPagination.Last
      key="last"
      disabled={currentPage === totalPages}
      onClick={() => onChange(totalPages)}
    />
  );

  return <BSPagination>{items}</BSPagination>;
}

export default Pagination;
